





































import Vue from "vue";
import IconButton from "../../../components/IconButton.vue";
import CarItemsTable from "./CarItemsTable.vue";
import * as api from "../services/CarNetApi";
import CarItem from "../models/CarItem";
import flowStore, { InvoiceFlowStore } from "@/modules/invoiceFlow/services/InvoiceFlowStore";
import CarPreCalcInfo from "../components/CarPreCalcInfo.vue";
import configuration, { AppConfiguration } from "@/models/Configuration";

interface Data {
  searchText: string;
  usedCars: CarItem[];
  flowStore: InvoiceFlowStore;
  carSearchVisible: boolean;
  configuration: AppConfiguration;
}

interface Methods {
  showCarSearch(): void;
  search(e: KeyboardEvent): void;
  clear(): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    CarItemsTable,
    IconButton,
    CarPreCalcInfo,
  },

  data() {
    return {
      flowStore,
      searchText: "",
      usedCars: [],
      carSearchVisible: false,
      configuration,
    };
  },

  methods: {
    showCarSearch() {
      this.carSearchVisible = !this.carSearchVisible;
    },

    search(e: KeyboardEvent) {
      if (e.key !== "Enter") {
        return;
      }
      return api.searchUsedCars(this.searchText).then((data) => (this.usedCars = data));
    },

    clear() {
      this.searchText = "";
      this.usedCars = [];
    },
  },
});
